// <div data-controller="components--horizontal-slider">
//
// </div>
import {Controller} from "@hotwired/stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {
  static targets = [ "slider", "track" ];
  static classes = [ "" ]
  static values = {
    height: Number
  };

  initialize() {
    this.slider = null;
  }

  get slidersCount() {
    return this.trackTarget.querySelectorAll(".splide__slide").length
  }

  connect() {
    // Use requestAnimationFrame to ensure smooth initialization after render
    requestAnimationFrame(() => {
      this.initializeSlider();
    });
  }
  
  initializeSlider() {
    this.slider = new Splide(this.sliderTarget, {
      perPage: 1,
      gap: "1rem",
      rewind : true,
      pagination: false,
      padding: 0,
      fixedHeight: this.heightValue,
      arrows: this.slidersCount > 1,
      // fixedWidth: 300,
      // arrowPath: "", 화살표 svg https://splidejs.com/guides/options/#arrowpath
    });

    this.slider.mount();
  }

  disconnect() {
    if (this.slider) {
      this.slider.destroy();
    }
  }
}